import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CurrentBenchmark } from '../models/current-benchmark.model';
import { ListsService } from './lists.service';
import targetStrategiesJSON from './json/target-strategies.json';
import { FactorStrategy } from '../models/factor-strategy.model';

@Injectable({
  providedIn: 'root'
})
export class LttrStrategyService {

  targetStrategy1: FactorStrategy;
  targetStrategy1Subject = new Subject<FactorStrategy>();
  targetStrategy2: FactorStrategy;
  targetStrategy2Subject = new Subject<FactorStrategy>();
  targetStrategy3: FactorStrategy;
  targetStrategy3Subject = new Subject<FactorStrategy>();

  targetStrategyBenchmark: CurrentBenchmark;
  targetStrategyBenchmarkSubject = new Subject<CurrentBenchmark>();

  constructor(private listsService: ListsService) {}

  async loadTargetStrategies() {
    console.log(targetStrategiesJSON);
    await this.listsService.cleanData(targetStrategiesJSON.efw);
    await this.listsService.cleanData(targetStrategiesJSON.efw.parameters);
    await this.listsService.cleanData(targetStrategiesJSON.minvar);
    await this.listsService.cleanData(targetStrategiesJSON.minvar.parameters);
    await this.listsService.cleanData(targetStrategiesJSON.efrp);
    await this.listsService.cleanData(targetStrategiesJSON.efrp.parameters);
    await this.listsService.cleanData(targetStrategiesJSON.benchmark);

    let strategy = new FactorStrategy(undefined);
    strategy.initFromData(targetStrategiesJSON.minvar);
    this.targetStrategy1 = strategy;
    this.emitTargetStrategy1();

    strategy = new FactorStrategy(undefined);
    strategy.initFromData(targetStrategiesJSON.efrp);
    this.targetStrategy2 = strategy;
    this.emitTargetStrategy2();

    strategy = new FactorStrategy(undefined);
    strategy.initFromData(targetStrategiesJSON.efw);
    this.targetStrategy3 = strategy;
    this.emitTargetStrategy3();

    let benchmark = new CurrentBenchmark(undefined);
    benchmark.initFromData(targetStrategiesJSON.benchmark);
    this.targetStrategyBenchmark = benchmark;
    this.emitTargetStrategyBenchmark();
  }

  emitTargetStrategy1() {
    // notify subscriptions and provide them with target strategy 1
    console.log('CALL StrategiesService.emitTargetStrategy1()');
    this.targetStrategy1Subject.next(this.targetStrategy1);
  }

  emitTargetStrategy2() {
    // notify subscriptions and provide them with target strategy 2
    console.log('CALL StrategiesService.emitTargetStrategy2()');
    this.targetStrategy2Subject.next(this.targetStrategy2);
  }

  emitTargetStrategy3() {
    // notify subscriptions and provide them with target strategy 3
    console.log('CALL StrategiesService.emitTargetStrategy3()');
    this.targetStrategy3Subject.next(this.targetStrategy3);
  }

  emitTargetStrategyBenchmark() {
    // notify subscriptions and provide them with target strategy benchmark
    console.log('CALL StrategiesService.emitTargetStrategyBenchmark()');
    this.targetStrategyBenchmarkSubject.next(this.targetStrategyBenchmark);
  }
}
